import { Hero } from "../index";
const Home = () => {
  return (
    <main>
      <Hero />
    </main>
  );
};

export default Home;
